import { axiosInstance, useSearch, useUtilities } from "helpers";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getTags } from "redux/reducers/siteSettings/tagsReducer";

export async function getAllTags(web, system_status) {
  return axiosInstance
    .get(`allTags`, {
      params: {
        api_key: localStorage.getItem("apikey"),
        website_id: web,
        system_status,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function deleteTag(id) {
  return axiosInstance
    .post(`deltag?tag_id=${id}&api_key=${localStorage.getItem("apikey")}`)
    .then((res) => ({ ...res.data, id }))
    .catch((err) => err);
}

export async function updateTag({ id, ...data }) {
  return axiosInstance
    .post("updatetag", {
      api_key: localStorage.getItem("apikey"),
      tag_id: id,
      ...data,
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function addTag(data) {
  return axiosInstance
    .post("addtag", {
      tag_by: localStorage.getItem("user_id"),
      api_key: localStorage.getItem("apikey"),
      ...data,
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function useGetTag(web = "", system_status = 0) {
  return useQuery(
    ["tagList", web, system_status],
    () => getAllTags(web, system_status),
    {
      select: (data) => data.data,
    }
  );
}

export function useTags(system_status = 0) {
  const { web = null } = useSearch();
  // const {
  //   dispatch,
  //   tags: { tags, loaded, website_id, system_status: systemStatus },
  // } = useUtilities();
  const { isLoading, error, data: tagsData = [] } = useGetTag(web, system_status);

  // console.log(tagsData);

  // useEffect(() => {
  //   if (tagsData && (website_id !== web || !loaded)) {
  //     dispatch(
  //       getTags({
  //         tags: tagsData,
  //         website_id: web,
  //         system_status,
  //       })
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   isLoading,
  //   error,
  //   tagsData,
  //   web,
  //   website_id,
  //   loaded,
  //   systemStatus,
  //   system_status,
  // ]);

  return { data: tagsData, isLoading: isLoading, error };
}

export function useAccountTags() {
  const { isLoading, error, data: tagsData = [] } = useGetTag(null, 0);

  return { data: tagsData, isLoading: isLoading, error };
}

export const addDefaultTemplateTag = async (id) => {
  return axiosInstance
    .post("adddefaulttemplatetag", {
      api_key: localStorage.getItem("apikey"),
      id,
    })
    .then((res) => res.data)
}

export async function removeDefaultTemplateTag(id) {
  return axiosInstance
    .post("removedefaulttemplatetag", {
      api_key: localStorage.getItem("apikey"),
      id,
    })
    .then((res) => res.data)
}